import {defHttp} from "xmgoing-server";
import {StorageUtils} from 'xmgoing-utils';

enum Api {
  getFileList = "/pe-attachment/attachment/readByBusinessId",
  delFileById = "/pe-attachment/attachment/delete/",
  delFileByBusId = "/pe-attachment/attachment/deleteByBusinessId",
  preview = "/pe-attachment/oss/filesInfoByBusinessId",
  wpsGetUrl = "/pe-attachment/attachment/getViewUrl/",
  attachmentDetailUrl = "/pe-attachment/oss/detail"
}

/**
 * @description: getFileList
 */
export function getFileList(businessId: string,businessType: string) {
  if (Array.isArray(businessId)) {
    businessId = businessId.join("")
  }
  return defHttp.post<any>(
    {url: Api.getFileList, params: {businessId,businessType}},
    {errorMessageMode: "none"}
  );
}

/**
 * 删除附件 根据附件id
 * @param fileId
 */
export function delFileById(fileId: string) {
  return defHttp.post<any>(
    {url: Api.delFileById + fileId, params: {}},
    {errorMessageMode: "none"}
  );
}

/**
 * 获取wps 路径
 * @param fileId
 */
export async function getViewUrlDbPath(fileId: string) {
  return defHttp.post<any>(
    {url: Api.wpsGetUrl + fileId, params: {}},
    {errorMessageMode: "none"}
  );
}

//从数据库获取
export async function  getAttachmentDetailFromDb(){
  return  defHttp.post<any>(
    {url: Api.attachmentDetailUrl, params: {}},
    {errorMessageMode: "none"}
  );
}

/**
 * 获取附件配置明细信息
 */
export async function getAttachmentDetail() {
  const fileStr = StorageUtils.getSessionItem("FileDetail");
  if (fileStr) {
    try {
      const fileStrObj = JSON.parse(fileStr);
      return fileStrObj;
    } catch (e) {
      StorageUtils.removeSessionItem("FileDetail");
      getAttachmentDetail();
    }
  }
}

/**
 * 根据busId 进行删除操作
 * @param businessId
 */
export function delFileByBusId(businessId: string) {
  return defHttp.post<any>(
    {url: Api.delFileByBusId, params: {businessId}},
    {errorMessageMode: "none"}
  );
}

// 拿到预览地址
export function previewApi(data: any) {
  return defHttp.post({
    url: Api.preview,
    data,
  });
}
